import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SITE } from "../data/site";

export default function Footer() {
  return (
    <footer className="relative mt-24 md:mt-40" data-testid="footer">
      <div className="hr-grad mx-6 md:mx-12" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <h2 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.95]">
              Let's build <br />
              <span className="grad-text">the future.</span>
            </h2>
            <Link
              to="/contact"
              className="btn-primary mt-8"
              data-testid="footer-cta"
            >
              Start a project <ArrowUpRight weight="bold" size={16} />
            </Link>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-mini text-[#0b2e5e]/50 mb-4">Explore</div>
            <ul className="space-y-2 text-[#0b2e5e]/75">
              <li><Link to="/" className="hover:text-[#0b2e5e]">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#0b2e5e]">About</Link></li>
              <li><Link to="/services" className="hover:text-[#0b2e5e]">Services</Link></li>
              <li><Link to="/works" className="hover:text-[#0b2e5e]">Works</Link></li>
              <li><Link to="/blog" className="hover:text-[#0b2e5e]">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-[#0b2e5e]">Contact</Link></li>
            </ul>

          </div>

          <div className="md:col-span-2">
            <div className="font-mono-mini text-[#0b2e5e]/50 mb-4">Social</div>
            <ul className="space-y-2 text-[#0b2e5e]/75">
              {SITE.socials.map((s) => (
                <li key={s.label}>
                  <a href={s.href} target="_blank" rel="noreferrer" className="hover:text-[#0b2e5e]">
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-mini text-[#0b2e5e]/50 mb-4">Reach</div>
            <ul className="space-y-2 text-[#0b2e5e]/75 text-sm">
              <li>{SITE.email}</li>
              <li>{SITE.phone}</li>
              <li>{SITE.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#0b2e5e]/50">
          <div>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</div>
          <div className="font-mono-mini">{SITE.tagline}</div>
        </div>
      </div>
    </footer>
  );
}
